module.exports = __webpack_public_path__ + "static/posanpally-d2c4cae93e26abb83e1c263ca0d0a4fd.jpg";